import React from 'react';
import GallerySection from '../components/GallerySection';

export default function GalleryPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--hr-bg)' }}>
      
      {/* Hero */}
      <section className="py-16 sm:py-20" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
        <div className="max-w-[1160px] mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h1 
            className="font-['Playfair_Display'] text-4xl sm:text-5xl font-bold"
            style={{ color: 'var(--hr-text)' }}
          >
            Transformations concrètes
          </h1>
          <p 
            className="text-xl max-w-3xl mx-auto leading-relaxed"
            style={{ color: 'var(--hr-text-muted)' }}
          >
            Découvrez des rénovations réalisées en Suisse romande. Même pièce, avant et après. Projet piloté, résultat garanti.
          </p>
        </div>
      </section>

      {/* Gallery */}
      <section className="py-12 sm:py-16">
        <div className="max-w-[1160px] mx-auto px-4 sm:px-6 lg:px-8">
          <GallerySection />
        </div>
      </section>
    </div>
  );
}